import React, { Component } from 'react';
import { loggedIn, getUserInfo, logout } from '../../helper'
export default function withAuth(AuthComponent) {
    return class AuthWrapped extends Component {
        constructor(props) {
            super(props);
            this.state = {
                user: null
            }
        }

        componentDidMount() {
            if (!loggedIn()) {
                if (this.props.history)
                    this.props.history.replace('/login')
            } else {
                try {
                    const profile = getUserInfo()
                    this.setState({
                        user: profile
                    })
                } catch (err) {
                    logout();
                    if (this.props.history)
                        this.props.history.replace('/login')
                }
            }
        }
        render() {
            if (this.state.user) {
                return (
                    <AuthComponent {...this.props} history={this.props.history} user={this.state.user} />
                )
            }
            else {
                return null
            }
        }
    }
}